import { useMemo, useCallback, useEffect, type DependencyList, type EffectCallback } from 'react';

/**
 * A custom hook that conditionally applies `useMemo` based on a condition.
 * used to add memoization to where is was absent before following feature flagging best practices.
 */
export const useMemoWithCondition = <T,>(
	fn: () => T,
	deps: DependencyList,
	condition: () => boolean,
): T => {
	if (condition()) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		return useMemo(fn, deps);
	}
	return fn();
};

/**
 * A custom hook that conditionally applies `useCallback` based on a condition.
 * used to add memoization to where is was absent before following feature flagging best practices.
 */
export const useCallbackWithCondition = <T extends Function>(
	fn: T,
	deps: DependencyList,
	condition: () => boolean,
): T => {
	if (condition()) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		return useCallback(fn, deps);
	}
	return fn;
};

/**
 * @deprecated you should not use this hook unles you are putting something un-useEffect-ed in a right way
 */
export const useEffectWithCondition = <T extends EffectCallback>(
	fn: T,
	deps: DependencyList,
	condition: () => boolean,
) => {
	if (condition()) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		return useEffect(fn, deps);
	}
	return fn;
};
